import { useEffect } from 'react'
import { useMeasure } from 'react-use'
import { ZoomTypes } from 'components/Zoom'
import { shrinkToFitFactor, Size } from './../utils'

const fitToScreenPadding = 20

function padSize(size: Size, padding: number): Size {
  return {
    width: Math.max(0, size.width - padding),
    height: Math.max(0, size.height - padding),
  }
}

const useScaleArtboard = <T extends Element>({
  artboardSize,
  currentZoom,
  onZoomChanged,
}: {
  artboardSize: Size
  currentZoom: ZoomTypes
  onZoomChanged: (newZoom: ZoomTypes) => void
}): [(instance: T) => void, Size, Size] => {
  const artboardHasSize = artboardSize.width && artboardSize.height
  let factor = currentZoom.factor

  const [ref, containerRect] = useMeasure<T>()
  const containerSize: Size = {
    width: containerRect.width,
    height: containerRect.height,
  }

  if (!factor || currentZoom.type === 'ZOOM_TO_FIT') {
    factor = shrinkToFitFactor({
      containerSize: padSize(containerSize, fitToScreenPadding * 2),
      itemSize: artboardSize,
    })
  }

  useEffect(() => {
    if (artboardHasSize && factor !== currentZoom.factor) {
      onZoomChanged({ type: currentZoom.type, factor } as ZoomTypes)
    }
  }, [artboardHasSize, factor, currentZoom, onZoomChanged])

  const scaledArtboardSize = {
    width: artboardSize.width * factor,
    height: artboardSize.height * factor,
  }

  return [ref, scaledArtboardSize, containerSize]
}

export default useScaleArtboard
